
  // import React, { useState, useEffect } from "react";
  // import { useTreeSpecies } from "../../hooks/species/useTreeSpecies";
  // import { useAddTreeSpecies } from "../../hooks/species/useAddTreeSpecies";
  // import { useUpdateTreeSpecies } from "../../hooks/species/useUpdateTreeSpecies";
  // import { useDeleteTreeSpecies } from "../../hooks/species/useDeleteTreeSpecies";
  // import {
  //   TextField,
  //   Button,
  //   Grid,
  //   InputAdornment,
  //   IconButton,
  //   Snackbar,
  //   Dialog,
  //   DialogTitle,
  //   DialogContent,
  //   DialogActions,
  //   Alert,
  // } from "@mui/material";
  // import { Trees, PlayCircle, Globe, Layers, Edit, Eye, Search, Plus, XCircle,Trash2 } from "lucide-react";
  // import "./TreeSpecies.css";
  // import FormDialog from "../../assets/FormDialog";

  // const TreeSpecies = () => {
  //   const [entriesPerPage, setEntriesPerPage] = useState(12);
  //   const [currentPage, setCurrentPage] = useState(1);

  //   // ── Search states ──
  //   const [searchQuery, setSearchQuery] = useState("");       // what user types
  //   const [activeSearch, setActiveSearch] = useState("");     // applied filter

  //   const [filters, setFilters] = useState({
  //     search: "",
  //     status: "",
  //     growth_rate: "",
  //     native_region: "",
  //   });

  //   const { species, loading, error, totalCount, setSpecies, refetch } = useTreeSpecies(
  //     filters,
  //     currentPage,
  //     entriesPerPage
  //   );

  //   const { addTreeSpecies, loading: adding, error: addError } = useAddTreeSpecies();
  //   const { updateTreeSpecies, loading: updating, error: updateError } = useUpdateTreeSpecies();
  //   const { deleteTreeSpecies, loading: deleting } = useDeleteTreeSpecies();

  //   const [openDialog, setOpenDialog] = useState(false);
  //   const [editingSpecies, setEditingSpecies] = useState(null);
  //   const [viewingSpecies, setViewingSpecies] = useState(null);
  //   const [deleteTarget, setDeleteTarget] = useState(null);
  //   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);


  //   const initialFormData = {
  //     scientific_name: "",
  //     common_name: "",
  //     local_name: "",
  //     marathi_name: "",
  //     family: "",
  //     genus: "",
  //     species_code: "",
  //     description: "",
  //     wood_density: "",
  //     average_height: "",
  //     average_girth: "",
  //     growth_rate: "",
  //     conservation_status: "",
  //     habitat: "",
  //     is_native: false,
  //     is_active: true,
  //     images: [],
  //   };

  //   const [formData, setFormData] = useState(initialFormData);
  //   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "error" });

  //   const totalPages = Math.ceil(totalCount / entriesPerPage) || 1;

  //   // ── Search handlers ──
  //   const handleApplySearch = () => {
  //     const trimmed = searchQuery.trim();
  //     setActiveSearch(trimmed);
  //     setFilters((prev) => ({ ...prev, search: trimmed }));
  //     setCurrentPage(1);
  //   };

  //   const handleClearSearch = () => {
  //     setSearchQuery("");
  //     setActiveSearch("");
  //     setFilters((prev) => ({ ...prev, search: "" }));
  //     setCurrentPage(1);
  //   };

  //   const handleSearchKeyDown = (e) => {
  //     if (e.key === "Enter") {
  //       e.preventDefault();
  //       handleApplySearch();
  //     }
  //   };

  //   // Auto-reset filter when query is cleared by user
  //   useEffect(() => {
  //     if (searchQuery.trim() === "" && activeSearch !== "") {
  //       handleClearSearch();
  //     }
  //   }, [searchQuery]);

  //   const handleOpenDialog = () => {
  //     setEditingSpecies(null);
  //     setFormData(initialFormData);
  //     setOpenDialog(true);
  //   };

  //   const handleCloseDialog = () => {
  //     setOpenDialog(false);
  //     setEditingSpecies(null);
  //     setFormData(initialFormData);
  //   };

  //   const handleEditClick = (species) => {
  //     setEditingSpecies(species.id);
  //     setFormData({
  //       scientific_name: species.scientific_name || "",
  //       common_name: species.common_name || "",
  //       local_name: species.local_name || "",
  //       marathi_name: species.marathi_name || "",
  //       family: species.family || "",
  //       genus: species.genus || "",
  //       species_code: species.species_code || "",
  //       description: species.description || "",
  //       wood_density: species.wood_density || "",
  //       average_height: species.average_height || "",
  //       average_girth: species.average_girth || "",
  //       growth_rate: species.growth_rate || "",
  //       conservation_status: species.conservation_status || "",
  //       habitat: species.habitat || "",
  //       is_native: species.is_native || false,
  //       is_active: species.is_active || true,
  //       images: [],
  //     });
  //     setOpenDialog(true);
  //   };

  //   const handleViewClick = (species) => {
  //     setViewingSpecies(species.id);
  //   };

  //   const handleCloseView = () => {
  //     setViewingSpecies(null);
  //   };
  //   const handleDeleteClick = (species) => {
  //     setDeleteTarget(species);
  //     setDeleteDialogOpen(true);
  //   };
  //     const confirmDelete = async () => {
  //       if (!deleteTarget) return;

  //       try {
  //         await deleteTreeSpecies(deleteTarget.id);

  //         setSpecies(prev => prev.filter(s => s.id !== deleteTarget.id));

  //         if (species.length <= 1 && currentPage > 1) {
  //           setCurrentPage(prev => prev - 1);
  //         }

  //         setSnackbar({
  //           open: true,
  //           message: "Species deleted successfully",
  //           severity: "success"
  //         });

  //       } catch (err) {
  //         console.error(err);
  //       }

  //       setDeleteDialogOpen(false);
  //       setDeleteTarget(null);
  //     };

  //     const cancelDelete = () => {
  //       setDeleteDialogOpen(false);
  //       setDeleteTarget(null);
  //     };

  //   const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: type === "checkbox" ? checked : files ? Array.from(files) : value,
  //     }));
  //   };

  //   const handleSubmit = async (updatedFormData) => {
  //     const errors = [];

  //     if (!updatedFormData.scientific_name?.trim()) {
  //       errors.push("Scientific Name");
  //     }
  //     if (!updatedFormData.common_name?.trim()) {
  //       errors.push("Common Name");
  //     }
  //     if (!updatedFormData.wood_density?.toString().trim()) {
  //       errors.push("Wood Density");
  //     }

  //     if (errors.length > 0) {
  //       setSnackbar({
  //         open: true,
  //         message: `Please fill all required fields: ${errors.join(", ")}.`,
  //         severity: "error",
  //       });
  //       return;
  //     }

  //     const payload = {};
  //     payload.scientific_name = updatedFormData.scientific_name.trim();
  //     payload.common_name = updatedFormData.common_name.trim();
  //     payload.wood_density = updatedFormData.wood_density;

  //     const optionalTextFields = [
  //       "local_name", "marathi_name", "family", "genus", "species_code",
  //       "description", "average_height", "average_girth", "habitat",
  //       "growth_rate", "conservation_status"
  //     ];

  //     optionalTextFields.forEach(field => {
  //       const val = updatedFormData[field];
  //       if (val !== undefined && val !== null && val !== "" && val !== "0" && val !== 0) {
  //         payload[field] = typeof val === "string" ? val.trim() : val;
  //       }
  //     });

  //     if (updatedFormData.is_native === true) {
  //       payload.is_native = true;
  //     }
  //     if (updatedFormData.is_active === true) {
  //       payload.is_active = true;
  //     }

  //     if (Array.isArray(updatedFormData.images) && updatedFormData.images.length > 0) {
  //       payload.images = updatedFormData.images;
  //     }

  //     try {
  //       let result;
  //       if (editingSpecies) {
  //         result = await updateTreeSpecies(editingSpecies, payload);
  //         setSpecies(prev =>
  //           prev.map(s => (s.id === editingSpecies ? { ...s, ...result } : s))
  //         );
  //         setSnackbar({ open: true, message: "Species updated!", severity: "success" });
  //       } else {
  //         result = await addTreeSpecies(payload);
  //         setSpecies(prev => [result, ...prev]);
  //         setSnackbar({ open: true, message: "Species created!", severity: "success" });
  //       }

  //       setCurrentPage(1);
  //       await refetch();

  //       setFormData(initialFormData);
  //       setOpenDialog(false);
  //       setEditingSpecies(null);
  //     } catch (err) {
  //       console.error("Save failed", err);
  //       setSnackbar({
  //         open: true,
  //         message: err.data || "Failed to save species.",
  //         severity: "error",
  //       });
  //     }
  //   };

  //   const handleFilterChange = (e) => {
  //     const { name, value } = e.target;
  //     setFilters((prev) => ({ ...prev, [name]: value }));
  //     setCurrentPage(1);
  //   };

  //   const getStatusConfig = (status) => ({
  //     slow: { label: "Slow", class: "status-slow" },
  //     moderate: { label: "Moderate", class: "status-moderate" },
  //     fast: { label: "Fast", class: "status-fast" },
  //     very_fast: { label: "Very Fast", class: "status-very-fast" },
  //   })[status] || { label: "Unknown", class: "status-unknown" };

  //   const getConservationConfig = (status) => ({
  //     LC: { label: "Least Concern", class: "conservation-lc" },
  //     NT: { label: "Near Threatened", class: "conservation-nt" },
  //     VU: { label: "Vulnerable", class: "conservation-vu" },
  //     EN: { label: "Endangered", class: "conservation-en" },
  //     CR: { label: "Critically Endangered", class: "conservation-cr" },
  //     EW: { label: "Extinct in Wild", class: "conservation-ew" },
  //     EX: { label: "Extinct", class: "conservation-ex" },
  //   })[status] || { label: "Unknown", class: "conservation-unknown" };

  //   const selectedSpecies = species.find((s) => s.id === viewingSpecies);

  //   const addSpeciesFields = [
  //     { name: "scientific_name", label: "Scientific Name", type: "text", required: true, gridWidth: 6, group: "Basic Info" },
  //     { name: "common_name", label: "Common Name", type: "text", required: true, gridWidth: 6, group: "Basic Info" },
  //     { name: "local_name", label: "Local Name", type: "text", gridWidth: 6, group: "Basic Info" },
  //     { name: "marathi_name", label: "Marathi Name", type: "text", gridWidth: 6, group: "Basic Info" },
  //     { name: "family", label: "Family", type: "text", gridWidth: 6, group: "Taxonomy" },
  //     { name: "genus", label: "Genus", type: "text", gridWidth: 6, group: "Taxonomy" },
  //     { name: "species_code", label: "Species Code", type: "text", gridWidth: 6, group: "Taxonomy" },
  //     { name: "description", label: "Description", type: "multiline", rows: 3, gridWidth: 12, group: "Characteristics" },
  //     { name: "wood_density", label: "Wood Density (g/cm³)", type: "number", required: true, gridWidth: 6, group: "Characteristics",helperText: "Ensure this value is less than or equal to 2.0", },
  //     { name: "average_height", label: "Average Height (m)", type: "number", gridWidth: 6, group: "Characteristics" },
  //     { name: "average_girth", label: "Average Girth (cm)", type: "number", gridWidth: 6, group: "Characteristics" },
  //     { name: "growth_rate", label: "Growth Rate", type: "select", gridWidth: 6, group: "Status",
  //       options: [
  //         { value: "slow", label: "Slow" },
  //         { value: "moderate", label: "Moderate" },
  //         { value: "fast", label: "Fast" },
  //         { value: "very_fast", label: "Very Fast" },
  //       ],
  //     },
  //     { name: "conservation_status", label: "Conservation Status", type: "select", gridWidth: 6, group: "Status",
  //       options: [
  //         { value: "LC", label: "Least Concern" },
  //         { value: "NT", label: "Near Threatened" },
  //         { value: "VU", label: "Vulnerable" },
  //         { value: "EN", label: "Endangered" },
  //         { value: "CR", label: "Critically Endangered" },
  //         { value: "EW", label: "Extinct in Wild" },
  //         { value: "EX", label: "Extinct" },
  //       ],
  //     },
  //     { name: "habitat", label: "Habitat", type: "text", gridWidth: 6, group: "Status" },
  //     { name: "is_native", label: "Native", type: "checkbox", gridWidth: 6, group: "Status" },
  //     { name: "is_active", label: "Active", type: "checkbox", gridWidth: 6, group: "Status" },
  //     { name: "images", label: "Upload Tree Images", type: "file", gridWidth: 12, group: "Images",
  //       inputProps: { multiple: true, accept: "image/*" },
  //       InputLabelProps: { shrink: true },
  //     },
  //   ];

  //   const editSpeciesFields = addSpeciesFields;
  //   const viewSpeciesFields = addSpeciesFields.map((field) => ({
  //     ...field,
  //     type: field.type === "select" || field.type === "checkbox" || field.type === "file" ? "text" : field.type,
  //     required: false,
  //     options: undefined,
  //     inputProps: undefined,
  //     InputLabelProps: undefined,
  //   }));

  //   const getViewInitialValues = (species) => ({
  //     ...species,
  //     growth_rate: getStatusConfig(species.growth_rate).label,
  //     conservation_status: getConservationConfig(species.conservation_status).label,
  //     is_native: species.is_native ? "Yes" : "No",
  //     is_active: species.is_active ? "Yes" : "No",
  //     images: species.images?.length ? species.images.join(", ") : "No images uploaded",
  //   });

  //   const totalSpecies = totalCount;
  //   const activeSpecies = species.filter((s) => s.is_active).length;
  //   const nativeSpecies = species.filter((s) => s.is_native).length;
  //   const totalFamilies = [...new Set(species.map((s) => s.family))].length;

  //   return (
  //     <div className="tree-species-page">
  //       <Snackbar
  //         open={snackbar.open}
  //         autoHideDuration={6000}
  //         onClose={() => setSnackbar({ ...snackbar, open: false })}
  //         anchorOrigin={{ vertical: "top", horizontal: "center" }}
  //       >
  //         <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%" }}>
  //           {snackbar.message}
  //         </Alert>
  //       </Snackbar>

  //       <div className="page-header">
  //         <div className="header-content">
  //           <h1 className="page-title">Tree Species</h1>
  //           <p className="page-subtitle">Manage and catalog tree species used across your geotagging projects.</p>
  //         </div>
  //       </div>

  //       <div className="summary-section">
  //         <div className="summary-card summary-card--blue">
  //           <div className="summary-card__icon"><Trees size={24} color="white" /></div>
  //           <div className="summary-card__content">
  //             <div className="summary-card__title">Total Species</div>
  //             <div className="summary-card__value">{totalSpecies}</div>
  //           </div>
  //         </div>
  //         <div className="summary-card summary-card--green">
  //           <div className="summary-card__icon"><PlayCircle size={24} color="white" /></div>
  //           <div className="summary-card__content">
  //             <div className="summary-card__title">Active Species</div>
  //             <div className="summary-card__value">{activeSpecies}</div>
  //           </div>
  //         </div>
  //         <div className="summary-card summary-card--teal">
  //           <div className="summary-card__icon"><Globe size={24} color="white" /></div>
  //           <div className="summary-card__content">
  //             <div className="summary-card__title">Native Species</div>
  //             <div className="summary-card__value">{nativeSpecies}</div>
  //           </div>
  //         </div>
  //         <div className="summary-card summary-card--purple">
  //           <div className="summary-card__icon"><Layers size={24} color="white" /></div>
  //           <div className="summary-card__content">
  //             <div className="summary-card__title">Total Families</div>
  //             <div className="summary-card__value">{totalFamilies}</div>
  //           </div>
  //         </div>
  //       </div>

  //       <div className="controls-section">
  //         <Grid container spacing={2} alignItems="center">
  //           <Grid item xs={12} md={4}>
  //             <TextField
  //               fullWidth
  //               placeholder="Scientific name, common name, family..."
  //               value={searchQuery}
  //               onChange={(e) => setSearchQuery(e.target.value)}
  //               onKeyDown={handleSearchKeyDown}
  //               InputProps={{
  //                 startAdornment: (
  //                   <InputAdornment position="start">
  //                     <IconButton
  //                       size="small"
  //                       onClick={handleApplySearch}
  //                       edge="start"
  //                       sx={{ ml: -1 }}
  //                     >
  //                       <Search size={16} color="#94a3b8" />
  //                     </IconButton>
  //                   </InputAdornment>
  //                 ),
  //                 endAdornment: searchQuery && (
  //                   <InputAdornment position="end">
  //                     <IconButton
  //                       size="small"
  //                       onClick={handleClearSearch}
  //                       edge="end"
  //                     >
  //                       <XCircle size={16} color="#94a3b8" />
  //                     </IconButton>
  //                   </InputAdornment>
  //                 ),
  //               }}
  //               sx={{
  //                 "& .MuiOutlinedInput-root": {
  //                   borderRadius: "10px",
  //                   backgroundColor: "white",
  //                 },
  //               }}
  //             />
  //           </Grid>
  //           <Grid item xs={12} md={4}>
  //             <select
  //               name="growth_rate"
  //               value={filters.growth_rate}
  //               onChange={handleFilterChange}
  //               className="filter-select"
  //             >
  //               <option value="">All Growth Rates</option>
  //               <option value="slow">Slow</option>
  //               <option value="moderate">Moderate</option>
  //               <option value="fast">Fast</option>
  //               <option value="very_fast">Very Fast</option>
  //             </select>
  //           </Grid>
  //           <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
  //             <Button variant="contained" onClick={handleOpenDialog} className="add-species-btn">
  //               <Plus size={16} /> Add Species
  //             </Button>
  //           </Grid>
  //         </Grid>
  //       </div>

  //       {loading ? (
  //         <div className="loading-state">Loading species...</div>
  //       ) : (
  //         <div className="table-container">
  //           <div className="table-scroll-wrapper">
  //             <table className="species-table">
  //               <thead>
  //                 <tr>
  //                   <th>ID</th>
  //                   <th>Scientific Name</th>
  //                   <th>Common Name</th>
  //                   <th>Local Name</th>
  //                   <th>Marathi Name</th>
  //                   <th>Family</th>
  //                   <th>Genus</th>
  //                   <th>Species Code</th>
  //                   <th>Growth Rate</th>
  //                   <th>Conservation Status</th>
  //                   <th>Native</th>
  //                   <th>Active</th>
  //                   <th>Actions</th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 {species.map((sp) => {
  //                   const growth = getStatusConfig(sp.growth_rate);
  //                   const cons = getConservationConfig(sp.conservation_status);

  //                   return (
  //                     <tr key={sp.id} className="table-row">
  //                       <td>{sp.tid || sp.id}</td>
  //                       <td>
  //                         <div className="name-cell">
  //                           {sp.thumbnail?.url ? (
  //                             <img
  //                               src={sp.thumbnail.url}
  //                               alt={sp.scientific_name}
  //                               className="thumbnail-avatar"
  //                               onError={(e) => {
  //                                 e.currentTarget.style.display = 'none';
  //                                 e.currentTarget.nextSibling.style.display = 'flex';
  //                               }}
  //                             />
  //                           ) : null}

  //                           <div
  //                             className="avatar"
  //                             style={{ display: sp.thumbnail?.url ? 'none' : 'flex' }}
  //                           >
  //                             {sp.scientific_name?.[0]?.toUpperCase() || "?"}
  //                           </div>

  //                           <div className="name-text">{sp.scientific_name}</div>
  //                         </div>
  //                       </td>
  //                       <td>{sp.common_name || "—"}</td>
  //                       <td>{sp.local_name || "—"}</td>
  //                       <td>{sp.marathi_name || "—"}</td>
  //                       <td>{sp.family || "—"}</td>
  //                       <td>{sp.genus || "—"}</td>
  //                       <td>{sp.species_code || "—"}</td>
  //                       <td>
  //                         <span className={`status-badge ${growth.class}`}>
  //                           {growth.label}
  //                         </span>
  //                       </td>
  //                       <td>
  //                         <span className={`status-badge ${cons.class}`}>
  //                           {cons.label}
  //                         </span>
  //                       </td>
  //                       <td>{sp.is_native ? "Yes" : "No"}</td>
  //                       <td>{sp.is_active ? "Yes" : "No"}</td>
  //                       <td>
  //                         <div className="table-actions">
  //                           <IconButton onClick={() => handleEditClick(sp)} size="small">
  //                             <Edit size={18} color="#10b981" />
  //                           </IconButton>
  //                           <IconButton onClick={() => handleViewClick(sp)} size="small">
  //                             <Eye size={18} color="#0284c7" />
  //                           </IconButton>
  //                           <IconButton 
  //                               onClick={() => handleDeleteClick(sp)} 
  //                               size="small"
  //                               disabled={deleting}
  //                               sx={{ color: deleting ? "#9ca3af" : "#ef4444" }}
  //                             >
  //                               <Trash2 size={18} />
  //                             </IconButton>
  //                         </div>
  //                       </td>
  //                     </tr>
  //                   );
  //                 })}
  //               </tbody>
  //             </table>
  //           </div>

  //           {species.length === 0 && !loading && (
  //             <div className="empty-state">
  //               <svg viewBox="0 0 24 24" className="empty-icon" fill="#9ca3af">
  //                 <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
  //               </svg>
  //               <h3>No record available</h3>
  //               <p>No tree species match your current search.</p>
  //             </div>
  //           )}
  //         </div>
  //       )}

  //       {totalCount > 0 && (
  //         <div className="pagination-section">
  //           <div className="pagination-info">
  //             Showing {species.length === 0 ? 0 : Math.min((currentPage - 1) * entriesPerPage + 1, totalCount)}–
  //             {Math.min(currentPage * entriesPerPage, totalCount)} of {totalCount} species
  //           </div>
  //           <div className="pagination-controls">
  //             <button
  //               onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
  //               disabled={currentPage === 1 || loading}
  //               className="pagination-btn"
  //             >
  //               Previous
  //             </button>

  //             {Array.from({ length: Math.min(totalPages, 7) }, (_, i) => {
  //               let pageNum = i + 1;
  //               if (totalPages > 7) {
  //                 if (currentPage <= 4) pageNum = i + 1;
  //                 else if (currentPage >= totalPages - 3) pageNum = totalPages - 6 + i;
  //                 else pageNum = currentPage - 3 + i;
  //               }
  //               return (
  //                 <button
  //                   key={pageNum}
  //                   className={`page-number ${currentPage === pageNum ? "active" : ""}`}
  //                   onClick={() => setCurrentPage(pageNum)}
  //                   disabled={loading}
  //                 >
  //                   {pageNum}
  //                 </button>
  //               );
  //             })}

  //             <button
  //               onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
  //               disabled={currentPage === totalPages || loading}
  //               className="pagination-btn"
  //             >
  //               Next
  //             </button>

  //             <select
  //               value={entriesPerPage}
  //               onChange={(e) => {
  //                 setEntriesPerPage(Number(e.target.value));
  //                 setCurrentPage(1);
  //               }}
  //               className="page-size-select"
  //               disabled={loading}
  //             >
  //               <option value={5}>5 per page</option>
  //               <option value={10}>10 per page</option>
  //               <option value={12}>12 per page</option>
  //               <option value={20}>20 per page</option>
  //             </select>
  //           </div>
  //         </div>
  //       )}

  //       <FormDialog
  //         open={openDialog}
  //         onClose={handleCloseDialog}
  //         title={editingSpecies ? "Edit Tree Species" : "Add Tree Species"}
  //         fields={editingSpecies ? editSpeciesFields : addSpeciesFields}
  //         initialValues={formData}
  //         onSubmit={handleSubmit}
  //         submitLabel={adding || updating ? "Saving..." : editingSpecies ? "Update" : "Create"}
  //         cancelLabel="Cancel"
  //         error={addError || updateError}
  //       />

  //       <FormDialog
  //         open={!!viewingSpecies}
  //         onClose={handleCloseView}
  //         title="View Tree Species"
  //         fields={viewSpeciesFields}
  //         initialValues={getViewInitialValues(selectedSpecies || {})}
  //         viewMode={true}
  //         submitLabel="Close"
  //         cancelLabel="Close"
  //       />
  //       <Dialog open={deleteDialogOpen} onClose={cancelDelete}>
  //         <DialogTitle>Confirm Delete</DialogTitle>

  //         <DialogContent>
  //           Are you sure you want to delete{" "}
  //           <strong>{deleteTarget?.scientific_name}</strong> ?
  //         </DialogContent>

  //         <DialogActions>
  //           <Button onClick={cancelDelete}>Cancel</Button>
  //           <Button color="error" variant="contained" onClick={confirmDelete}>
  //             Delete
  //           </Button>
  //         </DialogActions>
  //     </Dialog>

  //     </div>
  //   );
  // };

  // export default TreeSpecies;

import React, { useState, useEffect } from "react";
import { useTreeSpecies } from "../../hooks/species/useTreeSpecies";
import { useAddTreeSpecies } from "../../hooks/species/useAddTreeSpecies";
import { useUpdateTreeSpecies } from "../../hooks/species/useUpdateTreeSpecies";
import { useDeleteTreeSpecies } from "../../hooks/species/useDeleteTreeSpecies";
import { useTreeSpeciesDetail } from "../../hooks/species/useTreeSpeciesDetail"; // ← new hook
import {
  TextField,
  Button,
  Grid,
  InputAdornment,
  IconButton,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import { Trees, PlayCircle, Globe, Layers, Edit, Eye, Search, Plus, XCircle, Trash2 } from "lucide-react";
import "./TreeSpecies.css";
import FormDialog from "../../assets/FormDialog";

const TreeSpecies = () => {
  const [entriesPerPage, setEntriesPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);

  // ── Search states ──
  const [searchQuery, setSearchQuery] = useState("");
  const [activeSearch, setActiveSearch] = useState("");

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    growth_rate: "",
    native_region: "",
  });

  const { species, loading, error, totalCount, setSpecies, refetch } = useTreeSpecies(
    filters,
    currentPage,
    entriesPerPage
  );

  const [originalData, setOriginalData] = useState(null);
  const { addTreeSpecies, loading: adding, error: addError } = useAddTreeSpecies();
  const { updateTreeSpecies, loading: updating, error: updateError } = useUpdateTreeSpecies();
  const { deleteTreeSpecies, loading: deleting } = useDeleteTreeSpecies();

  const [openDialog, setOpenDialog] = useState(false);
  const [editingSpecies, setEditingSpecies] = useState(null);
  const [viewingSpeciesId, setViewingSpeciesId] = useState(null); // only store ID → fetch detail on demand
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  // Detail hook for view mode
  const { detail: selectedSpecies, loading: detailLoading, error: detailError } =
    useTreeSpeciesDetail(viewingSpeciesId);

  const initialFormData = {
    scientific_name: "",
    common_name: "",
    local_name: "",
    marathi_name: "",
    family: "",
    genus: "",
    species_code: "",
    description: "",
    wood_density: "",
    average_height: "",
    average_girth: "",
    growth_rate: "",
    conservation_status: "",
    habitat: "",
    is_native: false,
    is_active: true,
    images: [],
  };

  const [formData, setFormData] = useState(initialFormData);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "error" });

  const totalPages = Math.ceil(totalCount / entriesPerPage) || 1;

  // ── Search handlers ──
  const handleApplySearch = () => {
    const trimmed = searchQuery.trim();
    setActiveSearch(trimmed);
    setFilters((prev) => ({ ...prev, search: trimmed }));
    setCurrentPage(1);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setActiveSearch("");
    setFilters((prev) => ({ ...prev, search: "" }));
    setCurrentPage(1);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleApplySearch();
    }
  };

  useEffect(() => {
    if (searchQuery.trim() === "" && activeSearch !== "") {
      handleClearSearch();
    }
  }, [searchQuery]);

  const handleOpenDialog = () => {
    setEditingSpecies(null);
    setFormData(initialFormData);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingSpecies(null);
    setFormData(initialFormData);
  };

  const handleEditClick = (species) => {
    setEditingSpecies(species.id);
   const data = {
      scientific_name: species.scientific_name || "",
      common_name: species.common_name || "",
      local_name: species.local_name || "",
      marathi_name: species.marathi_name || "",
      family: species.family || "",
      genus: species.genus || "",
      species_code: species.species_code || "",
      description: species.description || "",
      wood_density: species.wood_density || "",
      average_height: species.average_height || "",
      average_girth: species.average_girth || "",
      growth_rate: species.growth_rate || "",
      conservation_status: species.conservation_status || "",
      habitat: species.habitat || "",
      is_native: species.is_native || false,
      is_active: species.is_active || true,
      images: [],
    };

    setFormData(data);
    setOriginalData(data);
    setOpenDialog(true);
  };

  const handleViewClick = (species) => {
    setViewingSpeciesId(species.id);
  };

  const handleCloseView = () => {
    setViewingSpeciesId(null);
  };

  const handleDeleteClick = (species) => {
    setDeleteTarget(species);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;

    try {
      await deleteTreeSpecies(deleteTarget.id);
      setSpecies((prev) => prev.filter((s) => s.id !== deleteTarget.id));

      if (species.length <= 1 && currentPage > 1) {
        setCurrentPage((prev) => prev - 1);
      }

      setSnackbar({
        open: true,
        message: "Species deleted successfully",
        severity: "success",
      });
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Failed to delete species",
        severity: "error",
      });
    }

    setDeleteDialogOpen(false);
    setDeleteTarget(null);
  };

  const handleChange = (e) => {
  const { name, value, type, checked, files } = e.target;

  if (type === "file") {
    setFormData((prev) => ({
      ...prev,
      [name]: files ? [...files] : [],
    }));
    return;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};

  const handleSubmit = async (updatedFormData) => {
    const errors = [];

    if (!updatedFormData.scientific_name?.trim()) errors.push("Scientific Name");
    if (!updatedFormData.common_name?.trim()) errors.push("Common Name");
    if (!updatedFormData.wood_density?.toString().trim()) errors.push("Wood Density");

    if (errors.length > 0) {
      setSnackbar({
        open: true,
        message: `Please fill all required fields: ${errors.join(", ")}.`,
        severity: "error",
      });
      return;
    }

    const payload = {
      scientific_name: updatedFormData.scientific_name.trim(),
      common_name: updatedFormData.common_name.trim(),
      wood_density: updatedFormData.wood_density,
    };

    const optionalTextFields = [
      "local_name",
      "marathi_name",
      "family",
      "genus",
      "species_code",
      "description",
      "average_height",
      "average_girth",
      "habitat",
      "growth_rate",
      "conservation_status",
    ];

    optionalTextFields.forEach((field) => {
      const val = updatedFormData[field];
      if (val !== undefined && val !== null && val !== "" && val !== "0" && val !== 0) {
        payload[field] = typeof val === "string" ? val.trim() : val;
      }
    });

    if (updatedFormData.is_native === true) payload.is_native = true;
    if (updatedFormData.is_active === true) payload.is_active = true;

    if (Array.isArray(updatedFormData.images) && updatedFormData.images.length > 0) {
      payload.images = updatedFormData.images;
    }

    try {
      let result;
      if (editingSpecies) {
       let changedPayload = {};

        if (editingSpecies) {

          Object.keys(payload).forEach((key) => {

            if (key === "images") {
              if (payload.images?.length > 0) {
                changedPayload.images = payload.images;
              }
              return;
            }

            if (payload[key] !== originalData[key]) {
              changedPayload[key] = payload[key];
            }

          });

          result = await updateTreeSpecies(editingSpecies, changedPayload);

        } else {

          result = await addTreeSpecies(payload);

        }
        setSpecies((prev) =>
          prev.map((s) => (s.id === editingSpecies ? { ...s, ...result } : s))
        );
        setSnackbar({ open: true, message: "Species updated!", severity: "success" });
      } else {
        result = await addTreeSpecies(payload);
        setSpecies((prev) => [result, ...prev]);
        setSnackbar({ open: true, message: "Species created!", severity: "success" });
      }

      setCurrentPage(1);
      await refetch();

      setFormData(initialFormData);
      setOpenDialog(false);
      setEditingSpecies(null);
    } catch (err) {
      console.error("Save failed", err);
      setSnackbar({
        open: true,
        message: err.data || "Failed to save species.",
        severity: "error",
      });
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const getStatusConfig = (status) => ({
    slow: { label: "Slow", class: "status-slow" },
    moderate: { label: "Moderate", class: "status-moderate" },
    fast: { label: "Fast", class: "status-fast" },
    very_fast: { label: "Very Fast", class: "status-very-fast" },
  })[status?.toLowerCase()] || { label: "Unknown", class: "status-unknown" };

  const getConservationConfig = (status) => ({
    LC: { label: "Least Concern", class: "conservation-lc" },
    NT: { label: "Near Threatened", class: "conservation-nt" },
    VU: { label: "Vulnerable", class: "conservation-vu" },
    EN: { label: "Endangered", class: "conservation-en" },
    CR: { label: "Critically Endangered", class: "conservation-cr" },
    EW: { label: "Extinct in Wild", class: "conservation-ew" },
    EX: { label: "Extinct", class: "conservation-ex" },
  })[status?.toUpperCase()] || { label: "Unknown", class: "conservation-unknown" };

  const addSpeciesFields = [
    { name: "scientific_name", label: "Scientific Name", type: "text", required: true, gridWidth: 6, group: "Basic Info" },
    { name: "common_name", label: "Common Name", type: "text", required: true, gridWidth: 6, group: "Basic Info" },
    { name: "local_name", label: "Local Name", type: "text", gridWidth: 6, group: "Basic Info" },
    { name: "marathi_name", label: "Marathi Name", type: "text", gridWidth: 6, group: "Basic Info" },
    { name: "family", label: "Family", type: "text", gridWidth: 6, group: "Taxonomy" },
    { name: "genus", label: "Genus", type: "text", gridWidth: 6, group: "Taxonomy" },
    { name: "species_code", label: "Species Code", type: "text", gridWidth: 6, group: "Taxonomy" },
    { name: "description", label: "Description", type: "multiline", rows: 3, gridWidth: 12, group: "Characteristics" },
    {
      name: "wood_density",
      label: "Wood Density (g/cm³)",
      type: "number",
      required: true,
      gridWidth: 6,
      group: "Characteristics",
      helperText: "Ensure this value is less than or equal to 2.0",
    },
    { name: "average_height", label: "Average Height (m)", type: "number", gridWidth: 6, group: "Characteristics" },
    { name: "average_girth", label: "Average Girth (cm)", type: "number", gridWidth: 6, group: "Characteristics" },
    {
      name: "growth_rate",
      label: "Growth Rate",
      type: "select",
      gridWidth: 6,
      group: "Status",
      options: [
        { value: "slow", label: "Slow" },
        { value: "moderate", label: "Moderate" },
        { value: "fast", label: "Fast" },
        { value: "very_fast", label: "Very Fast" },
      ],
    },
    {
      name: "conservation_status",
      label: "Conservation Status",
      type: "select",
      gridWidth: 6,
      group: "Status",
      options: [
        { value: "LC", label: "Least Concern" },
        { value: "NT", label: "Near Threatened" },
        { value: "VU", label: "Vulnerable" },
        { value: "EN", label: "Endangered" },
        { value: "CR", label: "Critically Endangered" },
        { value: "EW", label: "Extinct in Wild" },
        { value: "EX", label: "Extinct" },
      ],
    },
    { name: "habitat", label: "Habitat", type: "text", gridWidth: 6, group: "Status" },
    { name: "is_native", label: "Native", type: "checkbox", gridWidth: 6, group: "Status" },
    { name: "is_active", label: "Active", type: "checkbox", gridWidth: 6, group: "Status" },
    {
      name: "images",
      label: "Upload Tree Images",
      type: "file",
      gridWidth: 12,
      group: "Images",
      inputProps: { multiple: true, accept: "image/*" },
      InputLabelProps: { shrink: true },
    },
  ];

  const editSpeciesFields = addSpeciesFields;

  const viewSpeciesFields = addSpeciesFields.map((field) => ({
    ...field,
    type: field.type === "select" || field.type === "checkbox" || field.type === "file" ? "text" : field.type,
    required: false,
    options: undefined,
    inputProps: undefined,
    InputLabelProps: undefined,
  }));

  const getViewInitialValues = (species = {}) => ({
  ...species,
  scientific_name: species.scientific_name || "—",
  common_name: species.common_name || "—",
  local_name: species.local_name || "—",
  marathi_name: species.marathi_name || "—",
  family: species.family || "—",
  genus: species.genus || "—",
  species_code: species.species_code || "—",
  description: species.description || "No description available",
  wood_density: species.wood_density ?? "—",
  average_height: species.average_height ?? "—",
  average_girth: species.average_girth ?? "—",
  habitat: species.habitat || "—",
  growth_rate: getStatusConfig(species.growth_rate).label,
  conservation_status: getConservationConfig(species.conservation_status).label,
  is_native: species.is_native ? "Yes" : "No",
  is_active: species.is_active ? "Yes" : "No",
  created_at: species.created_at ? new Date(species.created_at).toLocaleString() : "—",
  updated_at: species.updated_at ? new Date(species.updated_at).toLocaleString() : "—",
  images: species.images?.length
    ? species.images.map((url, idx) => (
        <Box key={idx} sx={{ display: "inline-block", mr: 1.5, mb: 1.5 }}>
          <img
            src={url}
            alt={`Image ${idx + 1}`}
            style={{ maxWidth: "180px", borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}
            onError={(e) => (e.target.style.display = "none")}
          />
        </Box>
      ))
    : "No images uploaded",
});

  const totalSpecies = totalCount;
  const activeSpecies = species.filter((s) => s.is_active).length;
  const nativeSpecies = species.filter((s) => s.is_native).length;
  const totalFamilies = [...new Set(species.map((s) => s.family))].filter(Boolean).length;

  return (
    <div className="tree-species-page">
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <div className="page-header">
        <div className="header-content">
          <h1 className="page-title">Tree Species</h1>
          <p className="page-subtitle">Manage and catalog tree species used across your geotagging projects.</p>
        </div>
      </div>

      <div className="summary-section">
        <div className="summary-card summary-card--blue">
          <div className="summary-card__icon"><Trees size={24} color="white" /></div>
          <div className="summary-card__content">
            <div className="summary-card__title">Total Species</div>
            <div className="summary-card__value">{totalSpecies}</div>
          </div>
        </div>
        <div className="summary-card summary-card--green">
          <div className="summary-card__icon"><PlayCircle size={24} color="white" /></div>
          <div className="summary-card__content">
            <div className="summary-card__title">Active Species</div>
            <div className="summary-card__value">{activeSpecies}</div>
          </div>
        </div>
        <div className="summary-card summary-card--teal">
          <div className="summary-card__icon"><Globe size={24} color="white" /></div>
          <div className="summary-card__content">
            <div className="summary-card__title">Native Species</div>
            <div className="summary-card__value">{nativeSpecies}</div>
          </div>
        </div>
        <div className="summary-card summary-card--purple">
          <div className="summary-card__icon"><Layers size={24} color="white" /></div>
          <div className="summary-card__content">
            <div className="summary-card__title">Total Families</div>
            <div className="summary-card__value">{totalFamilies}</div>
          </div>
        </div>
      </div>

      <div className="controls-section">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              placeholder="Scientific name, common name, family..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleSearchKeyDown}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton size="small" onClick={handleApplySearch} edge="start" sx={{ ml: -1 }}>
                      <Search size={16} color="#94a3b8" />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={handleClearSearch} edge="end">
                      <XCircle size={16} color="#94a3b8" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  backgroundColor: "white",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <select
              name="growth_rate"
              value={filters.growth_rate}
              onChange={handleFilterChange}
              className="filter-select"
            >
              <option value="">All Growth Rates</option>
              <option value="slow">Slow</option>
              <option value="moderate">Moderate</option>
              <option value="fast">Fast</option>
              <option value="very_fast">Very Fast</option>
            </select>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" onClick={handleOpenDialog} className="add-species-btn">
              <Plus size={16} /> Add Species
            </Button>
          </Grid>
        </Grid>
      </div>

      {loading ? (
        <div className="loading-state">Loading species...</div>
      ) : (
        <div className="table-container">
          <div className="table-scroll-wrapper">
            <table className="species-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Scientific Name</th>
                  <th>Common Name</th>
                  <th>Local Name</th>
                  <th>Marathi Name</th>
                  <th>Family</th>
                  <th>Genus</th>
                  <th>Species Code</th>
                  <th>Growth Rate</th>
                  <th>Conservation Status</th>
                  <th>Native</th>
                  <th>Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {species.map((sp) => {
                  const growth = getStatusConfig(sp.growth_rate);
                  const cons = getConservationConfig(sp.conservation_status);

                  return (
                    <tr key={sp.id} className="table-row">
                      <td>{sp.tid || sp.id}</td>
                      <td>
                        <div className="name-cell">
                          {sp.thumbnail?.url ? (
                            <img
                              src={sp.thumbnail.url}
                              alt={sp.scientific_name}
                              className="thumbnail-avatar"
                              onError={(e) => {
                                e.currentTarget.style.display = "none";
                                e.currentTarget.nextSibling.style.display = "flex";
                              }}
                            />
                          ) : null}
                          <div className="avatar" style={{ display: sp.thumbnail?.url ? "none" : "flex" }}>
                            {sp.scientific_name?.[0]?.toUpperCase() || "?"}
                          </div>
                          <div className="name-text">{sp.scientific_name}</div>
                        </div>
                      </td>
                      <td>{sp.common_name || "—"}</td>
                      <td>{sp.local_name || "—"}</td>
                      <td>{sp.marathi_name || "—"}</td>
                      <td>{sp.family || "—"}</td>
                      <td>{sp.genus || "—"}</td>
                      <td>{sp.species_code || "—"}</td>
                      <td>
                        <span className={`status-badge ${growth.class}`}>{growth.label}</span>
                      </td>
                      <td>
                        <span className={`status-badge ${cons.class}`}>{cons.label}</span>
                      </td>
                      <td>{sp.is_native ? "Yes" : "No"}</td>
                      <td>{sp.is_active ? "Yes" : "No"}</td>
                      <td>
                        <div className="table-actions">
                          <IconButton onClick={() => handleEditClick(sp)} size="small">
                            <Edit size={18} color="#10b981" />
                          </IconButton>
                          <IconButton onClick={() => handleViewClick(sp)} size="small">
                            <Eye size={18} color="#0284c7" />
                          </IconButton>
                          <IconButton
                            onClick={() => handleDeleteClick(sp)}
                            size="small"
                            disabled={deleting}
                            sx={{ color: deleting ? "#9ca3af" : "#ef4444" }}
                          >
                            <Trash2 size={18} />
                          </IconButton>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {species.length === 0 && !loading && (
            <div className="empty-state">
              <svg viewBox="0 0 24 24" className="empty-icon" fill="#9ca3af">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
              </svg>
              <h3>No record available</h3>
              <p>No tree species match your current search.</p>
            </div>
          )}
        </div>
      )}

      {totalCount > 0 && (
        <div className="pagination-section">
          <div className="pagination-info">
            Showing {species.length === 0 ? 0 : Math.min((currentPage - 1) * entriesPerPage + 1, totalCount)}–
            {Math.min(currentPage * entriesPerPage, totalCount)} of {totalCount} species
          </div>
          <div className="pagination-controls">
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1 || loading}
              className="pagination-btn"
            >
              Previous
            </button>

            {Array.from({ length: Math.min(totalPages, 7) }, (_, i) => {
              let pageNum = i + 1;
              if (totalPages > 7) {
                if (currentPage <= 4) pageNum = i + 1;
                else if (currentPage >= totalPages - 3) pageNum = totalPages - 6 + i;
                else pageNum = currentPage - 3 + i;
              }
              return (
                <button
                  key={pageNum}
                  className={`page-number ${currentPage === pageNum ? "active" : ""}`}
                  onClick={() => setCurrentPage(pageNum)}
                  disabled={loading}
                >
                  {pageNum}
                </button>
              );
            })}

            <button
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages || loading}
              className="pagination-btn"
            >
              Next
            </button>

            <select
              value={entriesPerPage}
              onChange={(e) => {
                setEntriesPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="page-size-select"
              disabled={loading}
            >
              <option value={5}>5 per page</option>
              <option value={10}>10 per page</option>
              <option value={12}>12 per page</option>
              <option value={20}>20 per page</option>
            </select>
          </div>
        </div>
      )}

      <FormDialog
        open={openDialog}
        onClose={handleCloseDialog}
        title={editingSpecies ? "Edit Tree Species" : "Add Tree Species"}
        fields={editingSpecies ? editSpeciesFields : addSpeciesFields}
        initialValues={formData}
        onSubmit={handleSubmit}
        submitLabel={adding || updating ? "Saving..." : editingSpecies ? "Update" : "Create"}
        cancelLabel="Cancel"
        error={addError || updateError}
      />

      {/* View Dialog – now using fetched detail */}
      <FormDialog
        open={!!viewingSpeciesId}
        onClose={handleCloseView}
        title="View Tree Species"
        fields={viewSpeciesFields}
        initialValues={getViewInitialValues(selectedSpecies || {})}
        viewMode={true}
        submitLabel="Close"
        cancelLabel="Close"
        loading={detailLoading}
        customContent={
          detailLoading ? (
            <Box sx={{ textAlign: "center", py: 6 }}>
              <CircularProgress />
              <Typography variant="body1" sx={{ mt: 2 }}>
                Loading detailed information...
              </Typography>
            </Box>
          ) : detailError ? (
            <Alert severity="error" sx={{ my: 3 }}>
              {detailError}
            </Alert>
          ) : null
        }
      />

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete{" "}
          <strong>{deleteTarget?.scientific_name || "this species"}</strong>?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TreeSpecies;